import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

const Styled = styled(Box)(({ theme }) => ({
  "& .gridContainer": {
    padding: "0 1.5rem 1rem",
    justifyContent: "center",
    position: "relative",
    "& .MuiAlert-root": { justifyContent: "center", marginBottom: "0.625rem" },
    "& .MuiAlert-icon": { display: "none" },
    "& .MuiCard-root": {
      cursor: "pointer",
      margin: ".5rem",
    },
    "& .MuiCardHeader-root": {
      padding: "0.5rem 0.9375rem 0.5rem 0.75rem",
      "& .MuiTypography-root": {
        fontSize: "1rem",
        fontWeight: 500,
        ...theme.applyStyles("light", { fontWeight: 600 }),
      },
    },
    "& .MuiCardHeader-action": {
      color: "#fff",
      ...theme.applyStyles("light", { color: theme.palette.primary.main }),
    },
    "& .MuiCardContent-root": {
      padding: "0.5rem 0.9375rem",
      verticalAlign: "middle",
    },
    "& .card": {
      wordWrap: "break-word",
      "&:hover": {
        backgroundColor: "#6B8E23",
        ...theme.applyStyles("light", { backgroundColor: "#b1e580" }),
      },
    },
    "& .body1": {
      marginRight: "3.5rem",
      [theme.breakpoints.down("sm")]: {
        marginRight: "1rem",
      },
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0 0rem 1rem",
    },
  },
}));
export default Styled;
